export const TRACKING_POINT_TYPE = "0";

export const IMPACTION_POINT_TYPE = "1";

export const PAR_TYPE_RASTREIO_SLUG = "rastreio";
